import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "./analytics";

export default function GoogleAnalyticsPageViews() {
  const location = useLocation();
  const lastRoute = useRef(null);
  const route = `${location.pathname}${location.search}`;

  useEffect(() => {
    if (lastRoute.current === route) return;
    lastRoute.current = route;
    trackPageView();
  }, [route]);

  return null;
}
